/*!
 * Copyright (c) 2024 Gateway Forge LLC.
 * All rights reserved.
 *
 * This software and its source code are proprietary and confidential to Gateway Forge LLC.
 * Unauthorized copying, distribution, or modification is prohibited.
 */

import React from 'react'
import { Column, Row } from '../../layout/components/dom'
import { useGlobal } from '../../utility/CTX';
import { ButtonPill, CampaignAccountButton, CreatorAccountButton, DownloadButton, FreeAccountButton, HostAccountButton, RoadmapButton } from '../../layout/components/button';
import { useSession } from '../../utility/Auth';
import { Helmet } from 'react-helmet';





function Pricing() {
    const { theme } = useGlobal();


    return <Column style={{flexGrow: 1, alignItems: 'center'}}>

        <Helmet>
            <title>Pricing - Gateway Forge</title>
            <meta name="description" content="All features available free and offline, unlimited storage." />

            <meta property="og:url" content="https://gatewayforge.com/pricing" />
            <meta property="og:title" content="Pricing - Gateway Forge" />
            <meta property="og:description" content="All features available free and offline, unlimited storage." />

        </Helmet>

        <PricingHeader />

        <Row style={{color: theme.yellow, fontSize: '1.2em', margin: `20px 20px 10px 20px`}}>
            <div>Alpha Testing</div>
            <div style={{color: theme.red, marginLeft: 10}}>{`(Closed)`}</div>
        </Row>

        <Column>
            We are currently in Alpha Development... Pricing info in the works.
        </Column>

        <Column style={{marginTop: 20}}>
            <h3 style={{maxWidth: 600, margin: '10px 20px', textAlign: 'center'}}>Take a look at our roadmap to get a sense of what is currently in development and what is coming soon!</h3>
            <Row style={{margin: '10px auto'}}>
                <RoadmapButton />
            </Row>
        
        </Column>
    </Column>
};






const PricingHeader = () => {

    return <Column style={{alignItems: 'center'}}>
        <h1 style={{padding: 20}}>Pricing</h1>
    </Column>
};






const TierOption = ({children}) => {
    const { theme } = useGlobal();

    return <Column style={{alignItems: 'center', background: theme.bg, margin: 20, borderRadius: 10, border: `1px solid ${theme.border}`, width: 200, maxWidth: 200, minWidth: 200, overflow: 'hidden'}}>
        {children}
    </Column>
}

const FreeTier = () => {
    const { theme } = useGlobal();
    const session = useSession();

    return <Column style={{alignItems: 'center', width: '100%'}}>
        <Column style={{marginBottom: 10, alignItems: 'center', width: '100%'}}>
            <h3 style={{width: '100%', background: theme.bg2, margin: 0, padding: 5, textAlign: 'center', color: theme.orange}}>Basic</h3>
            <h2><span style={{color: theme.orange}}>$FREE</span></h2>
            <p style={{textAlign: 'center', padding: 10}}>Access to all offline features.</p>
        </Column>

        {false && session && <DownloadButton />}
        {!session && <FreeAccountButton />}

        <div style={{height: 20}} />
    </Column>
}


const HostTier = () => {
    const { theme } = useGlobal();
    const session = useSession();

    return <Column style={{alignItems: 'center', width: '100%'}}>
        <Column style={{marginBottom: 10, alignItems: 'center', width: '100%'}}>
            <h3 style={{width: '100%', background: theme.bg2, color: theme.green, margin: 0, padding: 5, textAlign: 'center'}}>Host</h3>
            {false && <h2><span style={{color: theme.green}}>$4.99</span> / mo</h2>}
            <p style={{textAlign: 'center', padding: 10}}>Host projects on your local network, collaborate with others.</p>

        </Column>

        {false && session && <DownloadButton />}
        {session && <div style={{color: theme.green}}>Coming Soon</div>}
        {!session && <HostAccountButton />}

        <div style={{height: 20}} />
    </Column>
}



const CampaignTier = () => {
    const { theme } = useGlobal();
    const session = useSession();

    return <Column style={{alignItems: 'center', width: '100%'}}>
        <Column style={{marginBottom: 10, alignItems: 'center', width: '100%'}}>
            <h3 style={{width: '100%', background: theme.bg2, color: theme.blue, margin: 0, padding: 5, textAlign: 'center'}}>Campaign</h3>
            {false && <h2><span style={{color: theme.blue}}>$9.99</span> / mo</h2>}
            <p style={{textAlign: 'center', padding: 10}}>Manage and host D&D campaigns, track sessions, and enhance your experience with AI.</p>

        </Column>

        {false && session && <DownloadButton />}
        {session && <div style={{color: theme.blue}}>Coming Soon</div>}
        {!session && <CampaignAccountButton />}

        <div style={{height: 20}} />
    </Column>
}





export default Pricing